import script from "./ProjectTeamInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTeamInformation.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTeamInformation.vue?vue&type=style&index=0&id=3237aed8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3237aed8"]])

export default __exports__